import * as core from '../../../../../../../core'

import { query } from './create-stakeholder-modal.query'

export const RESOURCE = {
  payload: {
    alias: 'create.stakeholder.modal',
    description: 'Modal for creating a stakeholder',
    name: 'Create Stakeholder Modal',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
